import { DOCUMENT, Injectable, inject } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AnchorOffsetService {
  private readonly document: Document = inject(DOCUMENT);
  private probe: HTMLElement | null = null;

  public getTopOffset(): number {
    const view: Window | null = this.document.defaultView;
    if (!view) {
      return 0;
    }
    const paddingTop: string = view.getComputedStyle(this.getProbe()).paddingTop;
    return Number.parseFloat(paddingTop) || 0;
  }

  private getProbe(): HTMLElement {
    if (!this.probe) {
      const el: HTMLElement = this.document.createElement('div');
      el.setAttribute('aria-hidden', 'true');
      el.style.cssText =
        'position:fixed;top:0;left:0;width:0;height:0;visibility:hidden;pointer-events:none;' +
        'padding-top:var(--liberro-top-safezone-height);';
      this.document.body.appendChild(el);
      this.probe = el;
    }
    return this.probe;
  }
}